var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5256 3H14.4756C12.9156 3 11.6406 4.26 11.6406 5.82V7.23C11.6406 8.79 12.9006 10.05 14.4606 10.05H21.5256C23.0856 10.05 24.3456 8.79 24.3456 7.23V5.82C24.3606 4.26 23.0856 3 21.5256 3Z",
    fill: "#009b9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8586 7.23C25.8586 9.615 23.9086 11.565 21.5236 11.565H14.4736C12.0886 11.565 10.1386 9.615 10.1386 7.23C10.1386 6.39 9.23859 5.865 8.48859 6.255C6.37359 7.38 4.93359 9.615 4.93359 12.18V26.295C4.93359 29.985 7.94859 33 11.6386 33H24.3586C28.0486 33 31.0636 29.985 31.0636 26.295V12.18C31.0636 9.615 29.6236 7.38 27.5086 6.255C26.7586 5.865 25.8586 6.39 25.8586 7.23ZM18.5686 25.425H11.9986C11.3836 25.425 10.8736 24.915 10.8736 24.3C10.8736 23.685 11.3836 23.175 11.9986 23.175H18.5686C19.1836 23.175 19.6936 23.685 19.6936 24.3C19.6936 24.915 19.1836 25.425 18.5686 25.425ZM22.4986 19.425H11.9986C11.3836 19.425 10.8736 18.915 10.8736 18.3C10.8736 17.685 11.3836 17.175 11.9986 17.175H22.4986C23.1136 17.175 23.6236 17.685 23.6236 18.3C23.6236 18.915 23.1136 19.425 22.4986 19.425Z",
    fill: "#009b9b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.16cabf0f341d7b18bc17e4e96e24199c.svg";
export { ForwardRef as ReactComponent };